<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Fornecedores sugeridos</v-subheader>
        <v-divider/>
        <v-list class="rounded-card">
          <template v-for="(fornecedor, index) in requisicao.fornecedores">
            <v-list-item :key="fornecedor.id">
              <v-list-item-content>
                <v-list-item-title>
                  <px-span-tooltip
                    v-if="fornecedor.codigoInterno"
                    bottom
                    text-class="caption"
                    :text="`(${fornecedor.codigoInterno})`"
                    tooltip="Código interno do fornecedor"/>
                  {{ nomeFornecedor(fornecedor) }}
                  <px-popover-fornecedor :fornecedor-id="fornecedor.id" show-score />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <px-fornecedor-documento :fornecedor="fornecedor"/>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index !== (requisicao.fornecedores.length - 1)"
                       :key="`v-div-f${fornecedor.id}`"/>
          </template>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { DetalheFornecedorUtils } from 'px-components';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    documento() {
      return fornecedor => (fornecedor.pessoa.documento
        ? fornecedor.pessoa.documento : fornecedor.pessoa.cnpj);
    },
    nomeFornecedor() {
      return fornecedor => fornecedor.nome || fornecedor.pessoa.nome;
    },
  },
  methods: {
    buildFornecedor(fornecedor) {
      const { detalhesFornecedores } = this.requisicao;
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      return {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
    mapFornecedores() {
      this.requisicao.fornecedores = this.requisicao.fornecedores.map(f => this.buildFornecedor(f));
    },
  },
  created() {
    this.mapFornecedores();
  },
};
</script>
